export default __webpack_public_path__ + "static/media/rocket_anim_96.06f474c1.png";